export const MODEL_DEFINITIONS_LINK_LABEL = 'Model definitions';
